import { useEffect, useRef, useState } from "react";
import { PER_PAGE_SIZE } from "consts/transactions";
import useFetchResource from "hooks/useFetchResource";
import { getMerchantVisibleMethods } from "features/paymentMethods/api";
import type { PaymentMethodsResponse } from "features/paymentMethods/types";

const useVisiblePaymentMethods = () => {
    const [isLoading, setLoading] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState<PaymentMethodsResponse['data']['data']>([])

    const request = useFetchResource({
        shouldFetchAll: true,
        perPage: PER_PAGE_SIZE
    });

    const fetchVisiblePaymentMethods = () =>
        request(queryParams => getMerchantVisibleMethods(queryParams))
            .then(({ data }: PaymentMethodsResponse) => setPaymentMethods(data.data ?? []));

    const repository = {
        fetchVisiblePaymentMethods
    };

    const paymentMethodsRepositoryRef = useRef(repository);
    paymentMethodsRepositoryRef.current = repository;

    const getPaymentMethods = () => paymentMethods;

    useEffect(() => {
        const {
            fetchVisiblePaymentMethods
        } = paymentMethodsRepositoryRef.current;

        setLoading(true);

        fetchVisiblePaymentMethods()
            .finally(() => setLoading(false));
    }, []);

    return {
        isLoading,
        getPaymentMethods,
        fetchVisiblePaymentMethods
    };
};

export default useVisiblePaymentMethods;
